<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import OrderMedicineComponent from '../../../Common/OrderMedicineComponent.vue';
import config from "../../../../config.js";
import { errorAlert } from "../../../../plugins/alert";
import { getFieldValue } from "../../../../plugins/utility";
import qs from 'qs';
import axios from '../../../../plugins/axios.ts';
import { useOrderStore } from '../../../../stores/order';
import HelpAction from '../../../../compositions/HelpAction.vue';

const order = useOrderStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    identityId: {
      typ:Number,
      default:() => {
        return 0;
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    }
})

const { isVisible,identityId } = toRefs(props);
const listHeight = ref(74);
const listOrderTodayRef = ref();
const searchWord = ref('');
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
const orderFields = ref([
  {field_name: '採用品', field_key: 'product_detail_name', width: '50%', align: 'text-left', sorted:true},
  {field_name: '', field_key: 'order_target_type', width: '3%', align: 'text-center'},
  {field_name: '発注先', field_key: 'order_target', width: '25%', align: 'text-left'},
  {field_name: '発注数', field_key: 'ordered_number', width: '10%', align: 'text-center'},
  {field_name: '', field_key: 'action_wait_reverse', width: '15%', align: 'text-center'},
]);
const orderOptionFields = reactive({
  'search_word' : searchWord.value,
  'page_size' : 30,
  'is_today' : 1
});
const listSearch = (force = false,delay=0) => {
  orderOptionFields.search_word = searchWord.value;
  if (force == false) {
    listOrderTodayRef.value.resetItem(delay);
  } else {
    listOrderTodayRef.value.resetForceItem(delay);
  }
}
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}

const editSettingComplete = () => {
  listSearch(false,config.LIST_DELAY);
}
const editTransactionStatusChange = (identityId,status,reserveCount) => {
  let item = listOrderTodayRef.value.getItemById(identityId,'id');
  if (reserveCount == 0) {
    listOrderTodayRef.value.deleteItem(item);
    order.order_today_count--;
  }
  order.order_wait_count++;
}

watch(isVisible,(newValue, oldValue) => {
  if (newValue) {
    listSearch();
  }
})
watch(identityId,(newValue, oldValue) => {
  listSearch(true);
})

const domComplete = () => {
  order.order_today_count = listOrderTodayRef.value.getItemAllCount();
}
onMounted(() => {
  listSearch();
});
</script>

<style scoped>
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="order_today_list_help"
    ></help-action>
  </div>
  <div class="w-full flex items-center justify-end p-2 bg-gray-100 rounded">
    <div class="mb-2 mt-1">
    <search-box
        :search-word="searchWord"
        :on-change="onSearchWordChange"
        :on-enter="onSearchWordEnter"
        place-holder="採用品名を入力"
    ></search-box>
    </div>
  </div>
  <div class="w-full">
    <custom-list
      ref="listOrderTodayRef"
      :table-fields="orderFields"
      :option-fields="orderOptionFields"
      :api-url="apis.pharmacy_stock_list"
      :height="listHeight + 'vh'"
      :handler="handler"
      :dom-complete="domComplete"
    >
    <template v-slot:item="slotProps">
      <order-medicine-component
        :apis="apis"
        type="is_today"
        :pharmacy-wholesalers="pharmacyWholesalers"
        :identity-id="slotProps.item.id"
        :item="slotProps.item"
        :fields="orderFields"
        :edit-transaction-status-change="editTransactionStatusChange"
        :edit-setting-complete="editSettingComplete"
      ></order-medicine-component>
    </template>
    </custom-list>
  </div>

</div>
</template>

